import {makeAutoObservable} from "mobx";
import {TableDisplayEnum} from "../entity/enum/home";
import {TreeEntity} from "../entity/tree-entity";
import {SpecimenEntity} from "../entity/specimen-entity";
import {ResPage} from "../http/interface";
import {PageEntity} from "../entity/page-entity";

export  class ClassifyListStore {

    constructor() {
        makeAutoObservable(this)
    }

    public isExpend: boolean = false;
    public displayType: String = TableDisplayEnum.List;
    public detailModalOpen: boolean = false;
    public treeList:TreeEntity[] = [];
    public selectTreeList:TreeEntity[] = [];
    public condition = this.getDefaultCondition();
    public dataSource: SpecimenEntity[] = [];
    public plantDetail!:SpecimenEntity;
    public pagination:PageEntity = new PageEntity();
    public treeSearchKey:string = "";
    public selectedTree!:TreeEntity;
    public type:number = 1;

    public setType(type:number){
        this.type = type;
    }

    public setExpend(isExpend:boolean){
        this.isExpend = isExpend;
    }

    public setDisplayType(type: string){
        this.displayType = type;
    }

    public setDetailModalOpen(open: boolean) {
        this.detailModalOpen = open;
    }

    public setSelectTreeList(list: TreeEntity[]){
        this.selectTreeList = list;
    }

    public setPlantDetail(detail: SpecimenEntity) {
        this.plantDetail = detail;
    }

    public setSelectTreeEntity (selectEntity:TreeEntity){
        this.selectedTree = selectEntity;
    }

    private getDefaultCondition() {
        return {
            libraryCode: "",
            specimenName: "", // 中文名
            gatherer: "",
            gatherDate: "",
            gatherDateEnd: "",
            gatherDateStart:"",
            gatherNumber:"",
            province:"",
            district:""
        };
    }

    public setDataSource(list: SpecimenEntity[]){
        this.dataSource = list;
    }

    public resetQuery = () => {
        this.condition = this.getDefaultCondition();
        this.selectTreeList = [];
    }

    public clear() {
        this.isExpend = false;
        this.displayType = TableDisplayEnum.List;
        this.detailModalOpen = false;
        this.selectTreeList = [];
        this.condition = this.getDefaultCondition();
        this.treeSearchKey = "";
        this.pagination = new PageEntity();
        this.selectedTree = new TreeEntity();
        this.type = 1;
    }
}

